var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.47944V6.34567C1 3.39322 3.39322 1 6.34567 1V1C9.29811 1 11.6913 3.39322 11.6913 6.34567V6.47944C11.6913 9.17133 8.28311 13.2236 6.90956 14.748C6.607 15.084 6.08433 15.084 5.78178 14.748C4.40822 13.2236 1 9.17133 1 6.47944Z",
    stroke: "white",
    strokeWidth: 1.12529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78906 6.40941C4.78906 7.26885 5.48517 7.96496 6.34462 7.96496V7.96496C7.20406 7.96496 7.90017 7.26885 7.90017 6.40941V6.38063C7.90017 5.52118 7.20406 4.82507 6.34462 4.82507V4.82507C5.48517 4.82507 4.78906 5.52118 4.78906 6.38063",
    stroke: "white",
    strokeWidth: 1.12529,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.e4e35c9b22ec5dbb72ef0b14683ce6d7.svg";
export { ForwardRef as ReactComponent };